// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1DjTP","obliqueLineWrap":"membershipbadge_obliqueLineWrap__30bWi","obliqueLine":"membershipbadge_obliqueLine__RU78C"};